import { useEffect } from 'react'

import useChatViewers from './useChatViewers'
import useChatVisibility from './useChatVisibility'
import useInitSparkie from './useInitSparkie'
import useParticipantUpdate from './useParticipantUpdate'

const useSetupChat = () => {
  useChatViewers()
  useChatVisibility()
  useParticipantUpdate()

  const { initSparkie, destroySparkie } = useInitSparkie()

  useEffect(() => {
    const setup = async () => {
      await initSparkie()
    }

    setup()

    return () => {
      destroySparkie()
    }
  }, [initSparkie, destroySparkie])
}

export default useSetupChat
